// extracted by mini-css-extract-plugin
module.exports = {"tipButton":"Tips_tipButton__m-imB","tips":"Tips_tips__3fEQp"};